module.exports = __webpack_public_path__ + "img/page_title_3.3ef8643e.png";